/*
 * Copyright (c) 2026 Aegis AO Soft LLC and Alexander Orlov.
 * 34 Middletown Ave, Atlantic Highlands, NJ 07716
 *
 * THIS SOFTWARE IS THE CONFIDENTIAL AND PROPRIETARY INFORMATION OF
 * Aegis AO Soft LLC and Alexander Orlov.
 *
 * This code may be used, reproduced, modified, or distributed ONLY with the
 * prior written permission of Aegis AO Soft LLC / Alexander Orlov.
 *
 * Author: Alexander Orlov
 * Aegis AO Soft LLC
 */

/**
 * Is this deployment the dev sandbox?
 *
 * Dev is a play environment: anyone may register there, nothing is real and no money moves. The
 * registration screens say so out loud, so a visitor never mistakes a dev account for a live one.
 * PRODUCTION MUST STAY EXACTLY AS IT WAS — everything here answers false there.
 *
 * The answer comes from the Express host, which is the only party that knows at RUNTIME which
 * backend it proxies to: it injects window.__ENV__.SANDBOX into index.html (see server.js). The
 * build itself cannot carry the flag — CI builds with no .env, so any REACT_APP_* would ship empty
 * (see the runtime-config note in server.js).
 *
 * The hostname fallback covers `npm start`, where CRA serves index.html itself and no host has
 * injected anything. It only ever matches known dev hostnames, so an unrecognised host — every
 * production one — reads as production.
 */

const SANDBOX_HOSTNAMES = [
  /^localhost$/i,
  /^127\.0\.0\.1$/,
  /^\[::1\]$/,
  /^dev[-.]/i, // dev-owner.myeztoll.com
  /-dev\.azurewebsites\.net$/i, // aegis-owner-web-dev.azurewebsites.net
];

export function isSandbox(): boolean {
  if (typeof window === 'undefined') return false;

  const injected = (window as unknown as { __ENV__?: { SANDBOX?: boolean | string } }).__ENV__;
  if (injected && injected.SANDBOX !== undefined) {
    return injected.SANDBOX === true || injected.SANDBOX === 'true';
  }

  const host = window.location.hostname || '';
  return SANDBOX_HOSTNAMES.some(pattern => pattern.test(host));
}

export default isSandbox;
